import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import AnlageCard from "../anlage/AnlageCard";
import PlaceholderCard from "../anlage/PlaceholderCard";
import Api from "../../services/ApiService";

const AnlagenComponent = ({qr_code, setData, setStep, setError}) => {

    const API = new Api(); // API
    const [isLoading, setIsLoading] = useState(false);
    const [anlagen, setAnlagen] = useState([]);

    // API
    useEffect(() => {
        if (qr_code !== null && qr_code !== "") {
            setIsLoading(true);
            API.anlagen_get_by_qr(qr_code)
                .then(resp => {
                    if (resp.data.length > 0) {
                        setAnlagen(resp.data);
                        setIsLoading(false);
                    } else {
                        setStep(2);
                    }
                })
                .catch(err => {
                    if (err.code === "ERR_NETWORK") {
                        setError("Keine Verbindung zum Server, versuchen sie später.");
                    } else {
                        if (err.response.data.detail !== undefined) {
                            setError(err.response.data.detail)
                        } else {
                            setError("Unbekanntes Fehler.")
                        }
                    }
                    setIsLoading(false);
                    setStep("!");
                });
        }
    }, [])

    
    // Button "Weiter" handler
    const nextHandler = () => {
        var tmpAnlagen = [];
        if (anlagen && anlagen.length > 0) {
            tmpAnlagen = anlagen.map(obj => ({
                ...obj,
                register: true,
                registerDate: "",
                x_zaehlerstand_01: "",
                x_zaehlerstand_02: "",
            }));
            setData(prev => ({...prev, anlagen: tmpAnlagen}));
            setStep(2);
        }
    }
    
    // Views
    if (isLoading) return <Row className="justify-content-center"><h5 className="text-energo">Anlagen werden gesammelt</h5><PlaceholderCard /></Row>;
    return (
        <div>
            <Row>
                <Col xs="12" xl="12">
                    <h5 className="text-energo">Hier sehen Sie die Energieanlagen, die zu Ihrer Immobilie erfasst sind.</h5>
                </Col>
            </Row>
                {anlagen?.length === 0?
                    <div className="mt-3 mb-5">
                        <b className="text-danger">Sie haben keine Anlagen, bitte wenden Sie sich an Ihre Hausverwaltung.</b>
                    </div>
                :                
                    <div className="mt-3">
                        <Row className="justify-content-center">
                            {anlagen.length > 0 ? 
                                anlagen.map((anlage) => (
                                    <AnlageCard key={anlage.id} anlage={anlage} />
                            )) : 
                                <PlaceholderCard />
                            }
                        </Row>

                        <Row className="mt-3">
                            <Col className="text-end">
                                <Button onClick={() => nextHandler()} className="btn-energo">Weiter</Button>
                            </Col>
                        </Row>
                    </div>
                }
        </div>
    )
}

export default AnlagenComponent;